export default {
    'ModalFlujos.CrearFlujo': 'Create Flow',
    'ModalFlujos.EditarFlujo': 'Edit Flow',
    'sidebar.flujoetapas': 'Flow Stages',
};
